// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sealeo: PokeData = {
  "id": 364,
  "name": "sealeo",
  "height": 11,
  "weight": 876,
  "base_experience": 144,
  "types": [
    PokeType.ICE,
    PokeType.WATER
  ],
  "api_moves": [
    "body-slam",
    "growl",
    "water-gun",
    "surf",
    "ice-beam",
    "blizzard",
    "aurora-beam",
    "defense-curl",
    "rest",
    "snore",
    "powder-snow",
    "rollout",
    "swagger",
    "encore",
    "hail",
    "ice-ball",
    "sheer-cold",
    "water-pulse",
    "brine",
    "liquidation"
  ],
  "moves": [
    "body-slam",
    "growl",
    "blizzard",
    "sheer-cold",
    "brine",
    "liquidation",
    "ice-punch",
    "chilly-reception",
    "bubble",
    "aurora-veil",
    "aqua-jet",
    "aqua-tail",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 187,
    "item": null,
    "species": [
      {
        "name": "spheal",
        "order": 393,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sealeo",
        "order": 394,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": 363,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "walrein",
        "order": 395,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": 364,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 44,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 80,
    "speed": 45,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
